import styled from "styled-components";

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 132px;
  margin-left: 237px;
  margin-right: 237px;
  margin-bottom: 237px;
`;
export const Description = styled.p`
  font-size: 32px;
  font-family: Poppins-Regular;
  line-height: 65px;
  color: #1d1d1d;
  text-align: center;
  margin: auto;
`;

export const CardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10%;
  margin-left: 10%;
  margin-right: 10%;
  margin-bottom: 50px;
`;

export const Card = styled.div`
  border-radius: 0.25rem;
  box-shadow: 0 4px 8px 0 #00000029;
  flex: 34%;
  box-shadow: 0 4px 8px 0 #00000029;
  height: auto;
  margin-bottom: 40px;
  border-radius: 5px 5px 10px 10px;
`;
export const Title = styled.h1`
  min-height: 50%;
  background: #ffc766;
  display: flex;
  justify-content: center;
  align-items: center;
  /* height: 516px; */
  padding: 17%;
  text-transform: capitalize;
  border-radius: 5px 5px 10px 10px;
  text-align: center;
`;
export const CardDescription = styled.p`
  font-family: "Poppins-Light";
  text-align: center;
  padding: 10px;
  padding: 45px 54px 27px 54px;
  text-align: center;
  font-size: 24px;
  font: 24px;
  letter-spacing: 1.44px;
  color: #1d1d1d;
  opacity: 1;
  height: 400px;
`;
